import axios from 'axios'
import NProgress from 'nprogress'

const baseEnv = process.env.VUE_APP_BASEENV
const securityUrl = process.env.VUE_APP_FANBASESECURITY
const baseSecurityUrl = `${securityUrl}/${baseEnv}`

import { getSSORedirectUrl } from '../helpers/ssoHelper'

export class loginV2 {
  constructor() {}
  loginv2(payload, config) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/${getSSORedirectUrl(config, true)}`

      axios
        .post(url, payload)
        .then(response => {
          const r = response.data
          if (r.header && r.header.codigo == 1) {
            resolve(r.data)
          } else {
            // localStorage.removeItem('session');
            // location.reload();
            const msg = r.header && r.header.msg && String(r.header.msg).trim()
            reject(msg || 'Confirme seus dados, caso o erro persista entre em contato com o suporte.')
          }
        })
        .catch(err => {
          reject('Confirme sua conexão. ' + err.message)
        })
    })
  }
  validateMfa(payload, clientId) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/session/validateMfa/${clientId}`

      axios
        .post(url, payload)
        .then(response => {
          const r = response.data
          if (r.header && r.header.codigo == 1) {
            resolve(r)
          } else {
            location.reload()
            reject('Código inválido. ' + (r.header ? r.header.msg : 'Erro desconhecido'))
          }
        })
        .catch(err => {
          reject('Confirme sua conexão. ' + err.message)
        })
    })
  }

  mfaCodeResend(payload, clientId) {
    return new Promise((resolve, reject) => {
      let url = `${baseSecurityUrl}/session/mfaCodeResend/${clientId}`

      axios
        .post(url, payload)
        .then(response => {
          const r = response.data
          if (r.header && r.header.codigo == 1) {
            resolve(r)
          } else {
            reject('Erro ao reenviar código. ' + (r.header ? r.header.msg : 'Erro desconhecido'))
          }
        })
        .catch(err => {
          reject('Confirme sua conexão. ' + err.message)
        })
    })
  }

  getToken(clientId, clientSecret, code) {
    return new Promise((resolve, reject) => {
      // let url = `${baseSecurityUrl}token/v2?grant_type=authorization_code&client_id=${clientId}&code=${code}`;
      let url = `${baseSecurityUrl}/token/v2?grant_type=authorization_code&client_id=${clientId}&client_secret=${clientSecret}&code=${code}`

      axios
        .post(url)
        .then(response => {
          const r = response.data
          if (r.access_token && r.id_token) {
            resolve(r)
          } else {
            reject(
              'Não foi possível obter o token. ' + (r.error_description || 'Erro desconhecido'),
            )
          }
        })
        .catch(err => {
          reject('Confirme sua conexão. ' + err.message)
        })
    })
  }
}
